export class ConceptAlert {
    concept = null
    alertType = null
    conceptCode = null
    durationAlert = null
}